import { Link } from "react-router-dom";

// src/pages/PageNotFound.jsx
const PageNoteFoundServer = () => {
  return (
    <div className=" container h-screen flex justify-center items-center ">
      <div className="flex flex-col justify-center items-center space-y-4 md:space-y-8 pt-10">
        <h1 className="text-[3rem] md:text-[4rem] lg:text-[7rem] font-extrabold text-[#DF73FF] lg:leading-[6rem]">
          404 Error
        </h1>
        <p className="text-center text-lg md:text-2xl lg:text-3xl text-gray-400 font-bold">
          PAGE NOT FOUND
        </p>

        <Link
          to="/"
          className=" px-3 md:px-6 py-[10px] md:py-[14px] bg-[#FFC067] text-dark font-bold rounded shadow  transition  text-base md:text-lg  hover-liner  inline "
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default PageNoteFoundServer;
